/**
 * ドラッグ&ドロップオーバーレイコンポーネント
 * 共通化されたドロップ領域のUI
 */

import { FaImage, FaPaperclip } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@chakra-ui/react';

interface DropOverlayProps {
  isDragging: boolean;
  dropError: string;
  /** 画像専用モード（アイコンとテキストが変わる） */
  imageOnly?: boolean;
}

export const DropOverlay = ({ isDragging, dropError, imageOnly = false }: DropOverlayProps) => {
  const { t } = useTranslation();

  return (
    <>
      {/* ドラッグオーバーレイ */}
      {isDragging && (
        <Box
          position="absolute"
          inset={0}
          zIndex="overlay"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="primaryLight"
          backdropFilter="blur(4px)"
          animation="fadeIn"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={3}
            borderRadius="2xl"
            bg="transparent"
            p={4}
            boxShadow="lg"
          >
            {imageOnly ? (
              <Box as={FaImage} fontSize="5xl" color="secondary" animation="bounce" />
            ) : (
              <Box as={FaPaperclip} fontSize="5xl" color="secondary" animation="bounce" />
            )}
            <Text fontSize="lg" fontWeight="semibold" color="secondary">
              {imageOnly ? t('imageGenerator.dropHere') : t('fileAttachment.dropHere')}
            </Text>
          </Box>
        </Box>
      )}

      {/* ドロップエラー表示 */}
      {dropError && (
        <Box
          position="absolute"
          bottom={11.25}
          left="50%"
          zIndex="overlay"
          w="auto"
          h="auto"
          transform="translateX(-50%)"
          animation="slideUp"
          whiteSpace="nowrap"
          borderRadius="xl"
          border="1px solid"
          borderColor="red.300"
          bg="red.50"
          px={6}
          py={3}
          fontSize="md"
          fontWeight="medium"
          color="semantics.error"
          boxShadow="lg"
        >
          {dropError}
        </Box>
      )}
    </>
  );
};
